<a class="d-flex">
  <i class="material-icons ml-auto icon-close-dialog" (click)="close()">close</i>
</a>

<div class="d-flex table-title">
  <div class="text-dark-blue">
    <span class="text-fw-700">Trade history | </span>
    <span>Detail</span>
  </div>
  <div class="ml-auto">
    <div class="d-flex filter-column align-items-center" (click)="orderColumn(true)">
      <span>Filter</span>
      <div class="img ml-auto">
        <img class="icon-info ml-auto" src="./assets/images/icon-png/icon-info-dark.svg" alt="" />
        <span class="send-payment-tooltip tooltip-left">Drag and drop your
          <br> preferred items into either
          <br> the Visible or Hidden boxes
          <br> and click Confirm to view
          <br> your customised selection.</span>
      </div>
    </div>
  </div>
</div>

<div class="d-flex drag-drop-box" *ngIf="showOrderColumn">
  <div class="col-6 col-md-6 pr-1 pr-md-3">
    <div class="drag-container">
      <div class="section-heading">Visible columns</div>

      <div cdkDropList #pendingList="cdkDropList" [cdkDropListData]="todo" [cdkDropListConnectedTo]="[doneList]" class="item-list"
        (cdkDropListDropped)="drop($event)">
        <div class="item-box" *ngFor="let item of todo" cdkDrag>{{ item }}</div>
      </div>
    </div>
  </div>
  <div class="col-6 col-md-6 pl-1 pl-md-3">
    <div class="drag-container">
      <div class="section-heading">Hidden columns</div>
      <div cdkDropList #doneList="cdkDropList" [cdkDropListData]="done" [cdkDropListConnectedTo]="[pendingList]" class="item-list"
        (cdkDropListDropped)="drop($event)">
        <div class="item-box" *ngFor="let item of done" cdkDrag>{{ item }}</div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-6 col-md-4 col-xl-3 ml-auto pr-1 pr-md-3">
        <button class="btn btn-block btn-lg btn-greengo-o" (click)="orderColumn(false)">
          Cancel
        </button>
      </div>
      <div class="col-6 col-md-4 col-xl-3 pl-1 pl-md-3">
        <button class="btn btn-block btn-lg btn-greengo" (click)="reOrder()" npFocusOutClicked>
          Confirm
        </button>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="!isLoading">
  <ng-table 
    [rows]="rows" 
    [columns]="columns" 
    (cellClicked)="downloadOriginalTrade($event)">
  </ng-table>
</ng-container>